import { LookupDTO } from "./lookup.model";

export class DocumentFilterDTO {
    ID: number;
    ReferenceNumber: number;
    ReferenceSection: string;
    ReferenceYear: number;
    ReferenceMonth: ReferenceMonth;
    BillingFromDate: Date = new Date();
    BillingToDate: Date;
    IsImported: boolean ;
    FK_Customer : number;
    FK_Company: number;
    isAllDocuments : boolean = false;
    isPayed : boolean = false;
    isNotPayed : boolean = false;
    isSdiSent: boolean =false;
    isSdiNotSent: boolean =false;
    isSdiError: boolean =false;
    isSdiAE: boolean =false;
    isSdiMC: boolean =false;
    isSdiNENS: boolean =false;
    isSdiRC: boolean =false;
    invoiceType: InvoiceTypeFilter = InvoiceTypeFilter.ALL;
    isNamirialPay: boolean = false;
    isNamirialPayWithErrors: boolean = false;
    //Fattura passiva
    IdSdi: string;
    IsSDIFilter : boolean;

    //Fatturaz. plus
    IsPassiveCycle : boolean;

    //Scadenzario
    PaymentType : LookupDTO;
    ReminderLevel: any;
}

export enum ReferenceMonth {
    LAST_30GG = 1,
    LAST_MONTH = 2,
    LAST_3MONTHS = 3,
    LAST_6MONTHS = 4,
    LAST_9MONTHS = 5,
    CUSTOM = 6
}

export enum InvoiceTypeFilter {
    ALL = 1,
    INVOICE = 2,
    STS = 3,
}


